// FNP-534: form-shape Zod schema for the MeteringRecords filter (read-only module).
// Only backend-supported fields (state, customerId). meterCode + date range are
// deferred to FNP-538.
import {z} from 'zod';

export const FilterFormSchema = z.object({
    state: z.string().optional(),
    customerId: z.string().optional(),
});
